module.exports = __webpack_public_path__ + "static/Drops-74b819163d9f644303d4ef654a77f98b.png";